import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileBookingButton } from './components/MobileBookingButton';
import { SpecialOffersModal } from './components/SpecialOffersModal';
// Pages
import { HomePage } from './pages/HomePage';
import { TeamPage } from './pages/TeamPage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
import { LocationsPage } from './pages/LocationsPage';
import { BlogPage } from './pages/BlogPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { LandingPage } from './pages/LandingPage';
import { BlogPostPage } from './pages/BlogPostPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white flex flex-col" data-id="element-2">
        {/* Accessibility Skip Link */}
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand-dark focus:text-brand-gold focus:rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-gold" data-id="element-3">
          Skip to main content
        </a>

        <Header data-id="element-4" />

        <main id="main-content" className="flex-grow" data-id="element-5">
          <Routes data-id="element-6">
            <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
            <Route path="/team" element={<TeamPage data-id="element-10" />} data-id="element-9" />
            <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
            <Route path="/services" element={<ServicesPage data-id="element-14" />} data-id="element-13" />
            <Route path="/locations" element={<LocationsPage data-id="element-16" />} data-id="element-15" />
            <Route path="/blog/:postId" element={<BlogPostPage data-id="element-18" />} data-id="element-17" />
            <Route path="/blog" element={<BlogPage data-id="element-20" />} data-id="element-19" />
            <Route path="/payments" element={<PaymentsPage data-id="element-22" />} data-id="element-21" />
            <Route path="/reviews" element={<ReviewsPage data-id="element-24" />} data-id="element-23" />
            <Route path="/contact" element={<ContactPage data-id="element-26" />} data-id="element-25" />
            <Route path="/landing" element={<LandingPage data-id="element-28" />} data-id="element-27" />
          </Routes>
        </main>

        <Footer data-id="element-29" />
        <MobileBookingButton data-id="element-30" />
        <SpecialOffersModal data-id="element-31" />
      </div>
    </BrowserRouter>;
}